<template lang="pug">
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18" @click="emitClick($event)">
		<defs>
			<filter id="mtur6hip2a">
				<feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
			</filter>
			<path id="10bueiox8b" d="M16.884 1.129c-.488-.488-1.276-.488-1.765 0L9 7.235 2.88 1.116c-.488-.488-1.276-.488-1.764 0s-.488 1.276 0 1.765L7.236 9l-6.12 6.12c-.488.488-.488 1.276 0 1.764s1.276.488 1.765 0L9 10.764l6.12 6.12c.488.488 1.276.488 1.764 0s.488-1.276 0-1.765L10.764 9l6.12-6.12c.475-.475.475-1.276 0-1.751z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g filter="url(#mtur6hip2a)" transform="translate(-17 -19)">
				<g transform="translate(17 19)">
					<path fill="#D8D8D8" fill-opacity="0" d="M0 0H18V18H0z"/>
					<use fill="#303030" fill-rule="nonzero" xlink:href="#10bueiox8b"/>
				</g>
			</g>
		</g>
	</svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
